import moment from 'moment';

export const isoToUnix = (time: string): number => moment(time).unix();
